// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { Button, Fade } from '@mui/material';
import { useAppNavigate } from '@advisor-app/hooks';
import { useLocation } from 'react-router';
import { formatDate } from '@shared/ui-kit/utils/format-date';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface FreeTrialExpiresProps {
  canUserUseApp: boolean;
  expirationDate: number;
}

export const FreeTrialExpires = ({
  canUserUseApp,
  expirationDate,
}: FreeTrialExpiresProps) => {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();
  const isOnSusbcriptionPage = pathname.includes('account');

  const formattedExpirationDate = useMemo(
    () => formatDate(expirationDate, 'long', i18n.language) ?? '',
    [expirationDate, i18n.language],
  );

  const navigate = useAppNavigate();
  /* istanbul ignore next */
  const redirecToSusbcriptions = () => {
    navigate('/account');
  };

  return !canUserUseApp ? (
    <Fade
      in={!isOnSusbcriptionPage}
      className="fixed left-0 top-0 z-[999999] flex h-full w-full items-center justify-center overflow-hidden bg-slate-400/50 backdrop-blur-sm"
      onClick={redirecToSusbcriptions}
    >
      <div>
        <div className="flex flex-col items-center rounded-lg bg-white p-10">
          <p className="pb-4 text-center">
            <h3 className="mb-6 text-2xl font-bold text-secondary-dark">
              Expired subscription
            </h3>
            <span className="text-graph-text">
              Your last day of access was <br /> on {formattedExpirationDate}
            </span>
          </p>

          <Button color="secondary" onClick={redirecToSusbcriptions}>
            Update Subscription
          </Button>
        </div>
      </div>
    </Fade>
  ) : null;
};
